import React from 'react';
import { PaymentForm } from './PaymentForm';
import { CardViewWrapper } from '../CardFormView/styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
export var PaymentFormView = function PaymentFormView() {
  return /*#__PURE__*/React.createElement(CardViewWrapper, {
    isHidden: false,
    "data-test": DataTestAttributes.CARD_VIEW_CONTAINER
  }, /*#__PURE__*/React.createElement(PaymentForm, null));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/PaymentFormView.js
// module id = 4617
// module chunks = 11